<div class="container-fluid content-wrapper model-garden-page">
  <div class="page-title-wrapper d-flex align-items-end justify-content-between">
    <div>
      <h1 class="page-title model-garden-title">Model Garden</h1>
      <span class="page-subtitle">Browse and search all available models by category.</span>
    </div>
    <div class="badge-wrap">
      <span class="count-badge">{{ categories.length }} Categories</span>
    </div>
  </div>

  <div class="model-garden-shell">
    <form [formGroup]="filtersForm" class="model-search-form">
      <div class="form-group search-group">
        <input
          class="form-control model-search-input"
          type="text"
          (keyup)="search($any($event.target).value)"
          formControlName="search"
          placeholder="Find available models and inference"
          aria-label="Find available models and inference"
        />
        <i class="fa-solid fa-magnifying-glass model-search-icon"></i>
      </div>
    </form>

    <div class="garden-columns" *ngIf="filteredCategories.length > 0; else emptySearch">
      <section class="category-pane">
        <h2>1. Categories</h2>
        <div class="category-scroll">
          <button
            type="button"
            class="category-row"
            *ngFor="let category of filteredCategories"
            [class.active]="selectedCategoryId === category.id"
            (click)="selectCategory(category.id)"
          >
            <div class="category-title">{{ category.title }}</div>
            <div class="category-meta">{{ category.models.length }} models</div>
          </button>
        </div>
      </section>

      <section class="models-pane" *ngIf="selectedCategory as activeCategory">
        <h2>2. Models</h2>
        <div class="models-scroll">
          <header class="category-header">
            <h3>{{ activeCategory.title }}</h3>
            <p>{{ activeCategory.description }}</p>
          </header>

          <div class="models-grid">
            <article
              class="model-card"
              *ngFor="let model of visibleModels(activeCategory)"
              [class.clickable-card]="canOpenInClariStudio(model, activeCategory)"
              (click)="canOpenInClariStudio(model, activeCategory) ? openInClariStudio(model) : null"
            >
              <div class="model-top-row">
                <h4>{{ model.name }}</h4>
                <span class="context-pill">{{ model.contextWindow }}</span>
              </div>
              <div class="model-provider">
                <span>{{ model.provider }}</span>
                <span class="provider-id"> · {{ model.modelId }}</span>
              </div>
              <p class="model-description">{{ model.description }}</p>
              <button
                *ngIf="canOpenInClariStudio(model, activeCategory)"
                type="button"
                class="slider-btn"
                (click)="$event.stopPropagation(); openInClariStudio(model)"
              >
                Open in Clari Studio
              </button>
            </article>
          </div>

          <div class="slider-controls">
            <button type="button" class="slider-btn" [disabled]="!hasPrev(activeCategory)" (click)="slidePrev(activeCategory)">
              <i class="fa-solid fa-arrow-left"></i>
              Previous
            </button>
            <button type="button" class="slider-btn" [disabled]="!hasNext(activeCategory)" (click)="slideNext(activeCategory)">
              Next
              <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </section>
    </div>

    <ng-template #emptySearch>
      <div class="empty-state">
        <h3>No models found</h3>
        <p>Try another search term like provider name, capability, or model id.</p>
      </div>
    </ng-template>
  </div>
</div>
